'use strict';
/**
 *  Module  纸媒头版柱状图
 *  createBy Ly
 *  time:2016/3/13
 * Description
 */
angular.module('topNewsPaperColumnarDirModule', []).directive('columnarDir', ['$q', 'initHotHead', '$timeout', 'trsHttpService', function($q, initHotHead, $timeout, trsHttpService) {
    // Runs during compile
    return {
        restrict: 'E',
        replace: true,
        template: "<div ng-style=\"myStyle\"></div>",
        scope: {
            optionJsons: "=",
            newspaperlistDetail: '=',
            queryNewsPaper: "&",
            channel: "="
        },
        link: function(scope, iElement, iAttrs) {
            var myChart;
            var option;
            $timeout(function() {
                scope.myStyle = {
                    height: '600px',
                    width: '100%'
                };
                option = initHotHead.initTopNewspaperOption();
                option.xAxis[0].data = angular.copy(scope.optionJsons).name;
                // option.series[0].data = angular.copy(scope.optionJsons).data;
                option.series[0].data = [];
                angular.forEach(scope.optionJsons.data, function(dataValue, key) {
                    var groupMediaColor;
                    if (angular.isDefined(scope.optionJsons.flag[key])) {
                        groupMediaColor = scope.optionJsons.flag[key] === true ? '#C2C5CD' : '#C2C5CD';
                    } else {
                        groupMediaColor = '#C2C5CD';
                    }
                    option.series[0].data.push({ value: dataValue, itemStyle: { normal: { color: key == 0 ? '#d64541' : groupMediaColor } }, label: { normal: { color: '#3d3d3d' } } })
                });
                require(['echarts'], function(echarts) {
                    myChart = echarts.init(iElement[0]);
                    //myChart.setOption(option);
                    var emitType = {
                        'newspaper': "planNewsDetailList",
                        'website': "planWebDetailList",
                        'weixin': 'planWeixinDetailList',
                        'app': 'planAppDetailList'
                    };

                    function request(params) {
                        // params.color = 'green';
                        var originalOption = myChart._api.getOption();
                        angular.forEach(originalOption.series[0].data, function(value, key) {
                            var groupMediaColor;
                            if (angular.isDefined(scope.optionJsons.flag[key])) {
                                groupMediaColor = scope.optionJsons.flag[key] === true ? '#C2C5CD' : '#C2C5CD';
                            } else {
                                groupMediaColor = '#C2C5CD';
                            }
                            value.itemStyle.color = groupMediaColor;
                        });
                        originalOption.series[0].data[params.dataIndex].itemStyle.color = '#d64541';
                        originalOption.series[0].data[params.dataIndex].label.color = '#3d3d3d';
                        myChart.setOption(originalOption);
                        scope.newspaperlistDetail = params;
                        scope.newspaperlistDetail.guid = angular.copy(scope.optionJsons).guid[params.dataIndex];
                        scope.newspaperlistDetail.guids = angular.copy(scope.optionJsons).guids[params.dataIndex];
                        scope.newspaperlistDetail.sids = angular.copy(scope.optionJsons).sids[params.dataIndex];
                        scope.newspaperlistDetail.ids = angular.copy(scope.optionJsons).ids[params.dataIndex];
                        scope.$emit(emitType[scope.channel], scope.newspaperlistDetail);
                    };
                    myChart.on("click", request);
                    updataData();
                    scope.$watch("optionJsons", updataData);
                });
            }, 500);

            function updataData() {
                // option.xAxis[0].data = arrhot;
                option.xAxis[0].data = angular.copy(scope.optionJsons).name; //原来的，现在讲起
                // option.series[0].data = angular.copy(scope.optionJsons).data;
                option.series[0].data = [];
                angular.forEach(scope.optionJsons.data, function(dataValue, key) {
                    var groupMediaColor;
                    if (angular.isDefined(scope.optionJsons.flag[key])) {
                        groupMediaColor = scope.optionJsons.flag[key] === true ? '#C2C5CD' : '#C2C5CD';
                    } else {
                        groupMediaColor = '#C2C5CD';
                    }
                    option.series[0].data.push({ value: dataValue, itemStyle: { normal: { color: key == 0 ? '#d64541' : groupMediaColor } }, label: { normal: { color: '#3d3d3d', position: 'outside', show: true } } })
                });
                myChart.setOption(option, true);
            }
        }
    };
}]);